import React from "react";

/* Gold-standard list loading state — shimmering skeleton rows that mimic the
   real table shape. Drop straight into a register <tbody> while data loads:
     {loading ? <SkeletonRows cols={7} /> : rows.map(...)} */
export function SkeletonRows({ cols, rows = 12 }) {
  return (
    <>
      {[...Array(rows)].map((_, r) => (
        <tr key={r} className="border-b border-divider-row" data-testid={r === 0 ? "skeleton-row" : undefined} aria-hidden="true">
          {[...Array(cols)].map((_, c) => (
            <td key={c} className="px-4 py-2.5">
              <div className="eq-skeleton h-3" style={{ width: `${[62, 78, 55, 70, 48, 66][(r + c) % 6]}%`, animationDelay: `${(r * cols + c) * 45}ms` }} />
            </td>
          ))}
        </tr>
      ))}
    </>
  );
}

export default SkeletonRows;
